<div class="container-user-password-lost" *ngIf="sentTo.length == 0">
  <article class="message">
    <div class="message-body">
      Bitte hinterlegen Sie Ihre E-Mail-Adresse / Benutzernamen, um einen Link für die Zurücksetzung des Passwortes per
      E-Mail zu erhalten.
    </div>
  </article>
  <div [formGroup]="form">
    <div class="field is-flex-grow-1 mt-4">
      <label class="label">E-Mail-Adresse / Benutzername*</label>
      <div class="control">
        <input [ngClass]="error.length > 0 ? 'is-danger' : ''" class="input"
               (keydown.enter)="submit()"
               type="text" formControlName="username" name="username" placeholder="E-Mail-Adresse / Benutzername"/>
        <p *ngIf="error.length > 0" class="help is-danger">{{error}}</p>
      </div>
    </div>
  </div>
  <div class="mt-4 mb-4">
    <iw-shop-captcha-without-captcha (isVerified)="setCaptcha($event)"
                    [error]="(formStatus == 'submitForm' && !captcha)"></iw-shop-captcha-without-captcha>
    <article *ngIf="formStatus == 'submitForm' && !captcha" class="message is-danger">
      <div class="message-body">
        Bitte bestätigen Sie, dass Sie kein Roboter sind.
      </div>
    </article>
  </div>
  <div class="container-button mt-4">
    <iw-shop-forms-submit-button [classes]="buttonClass"  [formStatus]="formStatus" submitLabel="Link anfordern"
                                (submit)="submit()"></iw-shop-forms-submit-button >
  </div>
</div>
<div *ngIf="sentTo">
  <article class="message is-success">
    <div class="message-body">
      Eine E-Mail zur Zurücksetzung des Passwortes wurde erfolgreich an {{sentTo}} gesendet.
    </div>
  </article>
</div>
